import { render } from "./registration-account-created.vue?vue&type=template&id=53a477f1&scoped=true"
import script from "./registration-account-created.vue?vue&type=script&lang=js"
export * from "./registration-account-created.vue?vue&type=script&lang=js"

import "./registration-account-created.vue?vue&type=style&index=0&id=53a477f1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a477f1"]])

export default __exports__